import { useLocation } from 'react-router-dom';
import { useScheduleSearch } from '@/contexts/ScheduleSearchContext';
import { NavbarSearchPopoverControl } from '@/components/Layout/NavbarSearchPopoverControl';

export function ScheduleSearchNavbarControl() {
  const location = useLocation();
  const isSchedule = location.pathname === '/schedule';
  const { searchInput, setSearchInput, clearSearch } = useScheduleSearch();

  if (!isSchedule) return null;

  return (
    <NavbarSearchPopoverControl
      value={searchInput}
      onChange={setSearchInput}
      onClear={clearSearch}
      placeholder="Поиск по расписанию…"
      ariaLabel="Поиск по сессиям на листе расписания"
      dialogTitle="Поиск по расписанию"
    />
  );
}
